var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"intro"}},[_c('span',[_vm._v(_vm._s(_vm.timestamp))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('p',[_vm._v("цаг")]),_c('p',[_vm._v("мин")]),_c('p',[_vm._v("сек")])])
}]

export { render, staticRenderFns }